import $ from 'jquery';
import config from '../../../config';

// Get Employee
export function get_employee( id ){
	return dispatch => {

		$.ajax({
			method: 'GET',
			url: config.apiurl + 'employee.edit/',
			data: {
                method: 'GET_EMPLOYEE_EDIT',
                user_id: id
            }
		})
		.then(function (response) {
			dispatch({
				type: "GET_EMPLOYEE_EDIT",
				employeeedit: response
			})
		})

	}
}

// Get Employee
export function update_employee( id, data ){
	return dispatch => {

		$.ajax({
			method: 'POST',
			url: config.apiurl + 'employee.edit/',
			data: {
                method: 'UPDATE_EMPLOYEE_EDIT',
				user_id: id,
				data: data
            }
		})
		.then(function (response) {
			dispatch({
				type: "UPDATE_EMPLOYEE_EDIT",
				employeeedit: response
			})
		})

	}
}

// Get Department
export function get_department(){
	return dispatch => {

		$.ajax({
			method: 'GET',
			url: config.apiurl + 'employee.edit/',
			data: {
                method: 'GET_DEPARTMENT_EDIT',
            }
		})
		.then(function (response) {
			dispatch({
				type: "GET_DEPARTMENT_EDIT",
				employeeedit: response
			})
		})

	}
}


// Get all Employee
export function get_employee_list(){
	return dispatch => {

		$.ajax({
			method: 'GET',
			url: config.apiurl + 'employee.edit/',
			data: {
                method: 'GET_EMPLOYEE_LIST_EDIT',
            }
		})
		.then(function (response) {
			dispatch({
				type: "GET_EMPLOYEE_LIST_EDIT",
				employeeedit: response
			})
		})

	}
}

// Get Designation
export function get_designation(){
	return dispatch => {

		$.ajax({
			method: 'GET',
			url: config.apiurl + 'employee.edit/',
			data: {
                method: 'GET_DESIGNATION_EDIT',
            }
		})
		.then(function (response) {
			dispatch({
				type: "GET_DESIGNATION_EDIT",
				employeeedit: response
			})
		})

	}
}


// Get Company
export function get_company(){
	return dispatch => {

		$.ajax({
			method: 'GET',
			url: config.apiurl + 'employee.edit/',
			data: {
                method: 'GET_COMPANY_EDIT',
            }
		})
		.then(function (response) {
			dispatch({
				type: "GET_COMPANY_EDIT",
				employeeedit: response
			})
		})

	}
}

// Upload Profile Pic

export function upload_files( data ){
	return dispatch => {
		
		$.ajax({
			method: 'POST',
			dataType : 'json',
			url: config.apiurl + 'employee.edit/',
			data: data,
			processData: false,
			contentType: false
		}).then(function ( response ) {
			dispatch({
				type: "UPLOADED_PROFILE_PIC",
				employeeedit: response
			})
		})

	}

}

// Summary Actions

// Get Employee
export function get_summary_annual_leave( user ){
	return dispatch => {

		$.ajax({
			method: 'GET',
			url: config.apiurl + 'summary/',
			data: {
                method: 'GET_SUMMARY_ANNUAL_LEAVE',
				user: user
            }
		})
		.then(function (response) {
			dispatch({
				type: "GET_SUMMARY_ANNUAL_LEAVE",
				summary: response
			})
		})

	}
}


// Get Employee request
export function get_request_summary( user ){
	return dispatch => {

		$.ajax({
			method: 'GET',
			url: config.apiurl + 'summary/',
			data: {
                method: 'GET_REQUEST_SUMMARY',
				user: user
            }
		})
		.then(function (response) {
			dispatch({
				type: "GET_REQUEST_SUMMARY",
				summary: response
			})
		})

	}
}


// WEBPACK FOOTER //
// ./src/pages/profile/actions/selfservice.action.js